import { SubText, Text } from '@procurify/ui'

import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { MembersListItemStyled } from './styles/MembersListItemStyled'
import { MembersListStyled } from './styles/MembersListStyled'
import { WithApprovalPoolTooltipContentStyled } from './styles/WithApprovalPoolTooltipContentStyled'
import { UserLabel } from '../UserLabel'

const MAX_DISPLAYED_MEMBERS = 15
const MAX_MEMBERS_IN_COLUMN = 5

export interface IWithApprovalPoolTooltipContentProps {
  /** The members belonging to the approval pool */
  members: UserLike[]
}

export const WithApprovalPoolTooltipContent = ({
  members,
}: IWithApprovalPoolTooltipContentProps) => {
  const intl = useProcurifyIntl()
  const hasMoreMembers = members.length > MAX_DISPLAYED_MEMBERS
  const displayedMembers = hasMoreMembers
    ? members.slice(0, MAX_DISPLAYED_MEMBERS - 1)
    : members

  return (
    <WithApprovalPoolTooltipContentStyled>
      <Text bold>{intl.formatMessage(messages.heading)}</Text>
      <MembersListStyled
        rows={Math.min(displayedMembers.length, MAX_MEMBERS_IN_COLUMN)}
      >
        {displayedMembers.map((member, index) => (
          <MembersListItemStyled key={`${member.fullName}-${index}`}>
            <UserLabel
              user={member}
              WithUserTooltipProps={{ disabled: true }}
              showDelegatee
            />
          </MembersListItemStyled>
        ))}
        {hasMoreMembers && (
          <MembersListItemStyled>
            <SubText>
              {intl.formatMessage(messages.andMore, {
                count: members.length - displayedMembers.length,
              })}
            </SubText>
          </MembersListItemStyled>
        )}
      </MembersListStyled>
    </WithApprovalPoolTooltipContentStyled>
  )
}
